import { render, staticRenderFns } from "./tmk-products-and-questions.vue?vue&type=template&id=99af9eba&"
import script from "./tmk-products-and-questions.vue?vue&type=script&lang=js&"
export * from "./tmk-products-and-questions.vue?vue&type=script&lang=js&"
import style0 from "./tmk-products-and-questions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports